import { controlsContainerStyles } from "@insite/content-library/Widgets/ProductList/ProductListControlsContainer";
import { GridOffset } from "@insite/mobius/GridContainer";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const gridItemBase = css`
    width: 100%;
    flex-basis: initial;
    max-width: initial;
    min-width: 50px;

    ${mediaQueriesBP.minMD} {
        width: auto;
    }
`;

controlsContainerStyles.container = {
    ...controlsContainerStyles.container,

    css: css`
        ${GridOffset} {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;

            ${mediaQueriesBP.minMD} {
                flex-direction: row;
                align-items: center;
            }

            ${mediaQueriesBP.minLG} {
                justify-content: flex-start;
            }
        }
    `,
};

controlsContainerStyles.countGridItem = {
    ...controlsContainerStyles.countGridItem,

    css: css`
        && {
            ${gridItemBase}

            ${mediaQueriesBP.minMD} {
                && {
                    margin-right: auto;
                }
            }

            ${mediaQueriesBP.maxLG} {
                && {
                    width: 100%;
                }
            }
        }
    `,
};

controlsContainerStyles.sortGridItem = {
    ...controlsContainerStyles.sortGridItem,

    css: css`
        && {
            ${gridItemBase}
        }
    `,
};

controlsContainerStyles.filterGridItem = {
    ...controlsContainerStyles.filterGridItem,

    css: css`
        && {
            ${gridItemBase}
        }
    `,
};

controlsContainerStyles.viewSelectGridItem = {
    ...controlsContainerStyles.viewSelectGridItem,

    css: css`
        ${controlsContainerStyles.viewSelectGridItem?.css}

        && {
            ${gridItemBase}
        }
    `,
};
